// extracted by mini-css-extract-plugin
export default {"saveButton":"app-core-settings-edge-compute-SettingsFDO-SettingsFDO-module__save-button","fdoTable":"app-core-settings-edge-compute-SettingsFDO-SettingsFDO-module__fdo-table"};